import React from "react";
import { Translate } from "components/common/Translate/Translate";
import { ImageConverterPageTemplateInterface } from "@/templates/ImageConverterPageTemplateInterface";
import { DynamicImageView } from "components/common/DynamicImageView/DynamicImageView";

export const ImageConverterSection5 = ({ template,variables }: { template: ImageConverterPageTemplateInterface
    variables?: Record<any, any>}) => {
    const section = template["section5"];
    return (
        <div className={" flex flex-c ol md:flex-row items-center mt-24 md:mt-[150px]"}>
            <div className="flex-1 gap-2 hidden md:block">
                <DynamicImageView className="pr-16" image={section.graphics} alt={`${section.title}'s Sample Image`} />
            </div>
            <div className="flex-1 dark:text-white text-center md:text-left">
                <h2 className="text-24 font-semibold ">
                    <Translate keyName={section.title} variables={variables} />
                </h2>
                <p className="pt-1">
                    <Translate keyName={section.subTitle} variables={variables} />
                </p>
                {
                    section.subText && <p className="pt-1">
                        <Translate keyName={section.subText} variables={variables} />
                    </p>
                }
                <div className="flex-1 gap-2  md:hidden">
                    <DynamicImageView
                        image={section.graphics}
                        alt={`${section.title}'s Sample Image`}
                        className="pt-16"
                    />
                </div>
            </div>
        </div>
    );
};
